import $ from 'jquery';
import { libNodes, scrollToElement } from '../utils/Utils';

const $anchorLinks = $('.js_anchor');

const init = () => {
    $anchorLinks.on('click', function(e) {
        if (libNodes.$html.hasClass('scroll_animated')) {
            return;
        }

        e.preventDefault();

        const target = document.querySelector(`${this.hash}`);

        if (target) {
            scrollToElement(target);
        }
    });
};

export default init();
